import React from 'react';
import { Reveal } from './Section';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { PRICE } from '../config';
export function FinalCta() {
  return <section className="w-full bg-brand-purpleDark px-4 py-14 sm:py-20" data-id="element-88">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-89">
        <Reveal data-id="element-90">
          <h2 className="font-display text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-91">
            Hoy puedes recuperar tus tardes, tus noches…{' '}
            <span className="text-brand-teal" data-id="element-92">y tus domingos.</span>
          </h2>
        </Reveal>

        <Reveal className="mx-auto mt-8 max-w-md" data-id="element-93">
          <CtaButton sublabel={`Pago único · Cambio de moneda automático · Acceso de por vida`} data-id="element-94">
            Quiero el sistema por solo {PRICE}
          </CtaButton>
        </Reveal>

        <Reveal className="mx-auto mt-8 max-w-md rounded-2xl bg-white/5 p-4" data-id="element-95">
          <CountdownTimer data-id="element-96" />
        </Reveal>
      </div>
    </section>;
}